import { combineLatest } from 'rxjs';
import { Injectable } from '@angular/core';
import { CardTokenService } from './card-token.service';
import { mapTo } from 'rxjs/operators';
import { LoggingService } from '../../shared/services/core/logging.service';

@Injectable({ providedIn: 'root' })
export class CardTokenResolver {
  constructor(private cardTokenService: CardTokenService, private loggingService: LoggingService) {}

  resolve() {
    this.loggingService.info('Resolving card tokens...');
    return combineLatest([this.cardTokenService.fetchCardTokens(), this.cardTokenService.fetchDefaultCardToken()]).pipe(
      mapTo(null)
    );
  }
}
